import type {
  FighterConfig,
  FighterId,
  PlaceholderTemplateId,
} from "./game-types";
import { FIGHTER_IDS } from "./game-types";
import { getRosterFighter } from "./roster";

type PlaceholderNumbers = Omit<
  FighterConfig,
  "id" | "name" | "title" | "placeholderTemplate" | "accent"
>;

const DOG_TEMPLATE: PlaceholderNumbers = {
  moveSpeed: 455,
  dashSpeed: 650,
  airSpeed: 360,
  jumpSpeed: 940,
  weight: 0.92,
  width: 74,
  height: 156,
  attackDamage: 8,
  attackPower: 525,
  attackReach: 123,
  attackHeight: 90,
  specialDamage: 7,
  specialPower: 590,
  specialDuration: 0.78,
  specialTriggerTime: 0.28,
  projectileOffset: 70,
  projectileSpeed: 890,
  projectileRadius: 25,
  projectileLife: 1.35,
  projectileColor: "#64fff0",
  grabDamage: 6,
  grabReach: 90,
  throwPowerForward: 440,
  throwPowerBack: 460,
};

const TIGER_TEMPLATE: PlaceholderNumbers = {
  moveSpeed: 385,
  dashSpeed: 565,
  airSpeed: 310,
  jumpSpeed: 870,
  weight: 1.16,
  width: 93,
  height: 172,
  attackDamage: 11,
  attackPower: 660,
  attackReach: 141,
  attackHeight: 106,
  specialDamage: 10,
  specialPower: 720,
  specialDuration: 0.88,
  specialTriggerTime: 0.34,
  projectileOffset: 83,
  projectileSpeed: 710,
  projectileRadius: 34,
  projectileLife: 1.65,
  projectileColor: "#9b83ff",
  grabDamage: 8,
  grabReach: 102,
  throwPowerForward: 515,
  throwPowerBack: 540,
};

export const PLACEHOLDER_TEMPLATES: Record<
  FighterId,
  PlaceholderTemplateId
> = {
  dog: "dog",
  cat: "dog",
  tiger: "tiger",
  dolphin: "dog",
  horse: "tiger",
  lion: "tiger",
  elephant: "tiger",
  otter: "dog",
  penguin: "dog",
  wolf: "tiger",
  squirrel: "dog",
  trex: "tiger",
};

function createConfig(id: FighterId): FighterConfig {
  const fighter = getRosterFighter(id);
  const placeholderTemplate = PLACEHOLDER_TEMPLATES[id];
  const template =
    placeholderTemplate === "dog" ? DOG_TEMPLATE : TIGER_TEMPLATE;
  return {
    ...template,
    id,
    name: fighter.name,
    title: fighter.title,
    placeholderTemplate,
    accent: fighter.accent,
  };
}

export const FIGHTER_CONFIGS = Object.fromEntries(
  FIGHTER_IDS.map((id) => [id, createConfig(id)]),
) as Record<FighterId, FighterConfig>;

export function getFighterConfig(id: FighterId): FighterConfig {
  return FIGHTER_CONFIGS[id];
}

export function usesDogPlaceholder(id: FighterId): boolean {
  return FIGHTER_CONFIGS[id].placeholderTemplate === "dog";
}
